<template>
  <div class="com-header">

    <div class="dn-lower">
      <div class="com-content-1560 com-content">
        <div class="dn-left">
          <router-link :to="{name: 'home' }" class="com-size-all">
            <img src="../../assets/images/logo.png" alt="" class="dp-img1">
          </router-link>
        </div>
        <div class="dn-right">
          <div class="dn-nav">
            <div class="swiper-container swiper1">
              <div class="swiper-wrapper wrapper1">
                <div class="swiper-slide slide1">
                  <div class="dn-top">
                    <router-link :to="{name: 'home' }" class="dp-a1">Home</router-link>
                  </div>
                </div>
                <div class="swiper-slide slide1">
                  <div class="dn-top">
                    <router-link :to="{name: 'introduce' }" class="dp-a1">About Us</router-link>
                  </div>
                </div>
                <div class="swiper-slide slide1">
                  <div class="dn-top">
                    <a class="dp-a1" @click="clickSwitchProduct(1)">Product Center</a>
                  </div>
                  <!--
                  <div class="dn-bot">
                    <div class="com-content-1340 com-content1">
                      <div class="dn-zuo">
                        <div class="dn-sha">Product Center</div>
                        <div class="dn-xia">
                          <a class="dp-a1" @click="clickSwitchProduct(1)">Wooden Decoration</a>
                          <a class="dp-a1" @click="clickSwitchProduct(2)">Seasonal Decoration</a>
                        </div>
                      </div>
                      <div class="dn-you">
                        <img src="../../assets/images/9c5285e27b3702b7e057710334ae4ca.jpg"
                             alt="" class="dp-img1 com-object-fit-cover">
                      </div>
                    </div>

                  </div>
                  -->
                </div>
                <div class="swiper-slide slide1">
                  <div class="dn-top">
                    <a class="dp-a1" @click="clickSwitchNewsType(stateNews_getNewsType[0])">Exhibition Center</a>
                  </div>
                </div>
                <!--
                <div class="swiper-slide slide1">
                  <div class="dn-top">
                    <router-link :to="{name: 'download' }" class="dp-a1">Download Center</router-link>
                  </div>

                  <div class="dn-bot">
                    <div class="com-content-1340 com-content1">
                      <div class="dn-zuo">
                        <div class="dn-sha">User center</div>
                        <div class="dn-xia">
                          <router-link :to="{name: 'feedback' }" class="dp-a1">User feedback</router-link>
                          <router-link :to="{name: 'policy' }" class="dp-a1">Maintenance policy</router-link>
                          <router-link :to="{name: 'network' }" class="dp-a1">Service Network</router-link>
                          <router-link :to="{name: 'find' }" class="dp-a1">How to find us</router-link>
                          <router-link :to="{name: 'distinguish' }" class="dp-a1">How to identify crown tools
                          </router-link>
                          <router-link :to="{name: 'guide' }" class="dp-a1">Tool usage guide</router-link>
                          <router-link :to="{name: 'download' }" class="dp-a1">Download Center</router-link>
                        </div>
                      </div>
                      <div class="dn-you">
                        <img :src="stateimgBaseURL+'/uploads/20220303/150217af97e6150.jpg'"
                             alt="" class="dp-img1 com-object-fit-cover">
                      </div>
                    </div>
                  </div>

                </div>
 -->
                <div class="swiper-slide slide1">
                  <div class="dn-top">
                    <router-link :to="{name: 'contact2' }" class="dp-a1">Contact us</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="dn-menu-oper" @click="drawerMenu = true">
            <i class="iconfont icon-caidan_o"></i>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
        :visible.sync="drawerMenu" direction="ltr" size="50%">
      <el-menu
          :default-active="$route.path" class="el-menu-demo" router :unique-opened="true">
        <el-menu-item index="/home">
          <template slot="title">Home</template>
        </el-menu-item>
        <el-menu-item index="/brand/introduce">
          <template slot="title">About Us</template>
        </el-menu-item>
<!--
        <el-submenu index="/product">
          <template slot="title">Product Center</template>
          <el-menu-item index="/product/1/null">Wooden Decoration</el-menu-item>
          <el-menu-item index="/product/2/null">Seasonal Decoration</el-menu-item>
        </el-submenu>
        -->
        <el-menu-item index="/product/1/null">
          <template slot="title">Product Center</template>
        </el-menu-item>

        <el-menu-item index="/news/0">
          <template slot="title">Exhibition Center</template>
        </el-menu-item>
        <!--
        <el-menu-item index="/download/prodcatalogue">
          <template slot="title">Download center</template>
        </el-menu-item>
        -->
        <el-menu-item index="/contact/contact">
          <template slot="title">Contact us</template>
        </el-menu-item>
      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      drawerMenu: false,
    }
  },
  computed: {
    ...mapState(['statePerInfor', 'stateNews_getNewsType', 'stateIndex_link', 'stateimgBaseURL'])
  },
  created() {

    this.dataRequestbasis_bottomInfo()
    this.dataRequestnews_getNewsType()
    this.dataRequestindex_link()
  },
  methods: {
    clickSwitchProduct(item) {
      // this.$router.push('/product/' + item)
      this.$router.push({
        name: 'product',
        params: {
          class_id: item,
          zi_id: 'null',
        }
      })
    },
    // 资料设定
    dataRequestbasis_bottomInfo() {
      this.$api.user.basis_bottomInfo().then(res => {
        this.$store.commit('mutationsPerInfor', res.data.info)
      })
    },
    // 新闻类别
    dataRequestnews_getNewsType() {
      this.$api.user.news_getNewsType().then(res => {
        this.$store.commit('mutationsNews_getNewsType', res.data.list)
        // this.type_id = res.data.list[0].id
      })
    },
    // 首页外链
    dataRequestindex_link() {
      this.$api.user.index_link().then(res => {
        this.$store.commit('mutationsIndex_link', res.data.link[0])
      })
    },
    clickSwitchNewsType(item) {
      this.$router.push('/news/' + item.id)
    },
  },

}
</script>

<style scoped lang="scss">
.com-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 101;
  background: #ffffff;
  box-shadow: 0 10*$pc-conversion 10*$pc-conversion rgba(0, 0, 0, .1);

  .dn-upper {
    background: #666666;
    color: #ffffff;

    .com-content {
      display: flex;
      justify-content: flex-end;
    }

    .dn-right {
      display: flex;
      align-items: center;

      .dp-a1 {
        height: 36px;
        display: flex;
        align-items: center;
        margin: 0 0 0 16px;
        color: #ffffff;

        &:last-of-type {
          padding: 0 15px;
          background: #787878;
        }

        i {
          font-size: 20px;
          margin: 0 7px;
        }
      }
    }
  }

  .dn-lower {
    .com-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .dn-left {
      .dp-img1 {
        height: 76px;
      }
    }

    .dn-right {
      display: flex;
      align-items: center;

      .dn-nav {
        .swiper1 {
          overflow: visible;

          .wrapper1 {
            transform: none;
          }

          .slide1 {
            width: auto;
            padding: 0 25*$pc-conversion;

            &:hover {
              .dn-top {
                .dp-a1 {
                  color: $color1;
                }
              }

              .dn-bot {
                display: block;
                animation: fadeInUp1 0.4s ease;
              }
            }

            .dn-top {
              .dp-a1 {
                padding: 40*$pc-conversion 0;
                display: block;
                color: #333333;
                font-size: 16px;
                cursor: pointer;
                text-transform: capitalize;

                &.router-link-active {
                  color: $color1;
                }
              }
            }

            .dn-bot {
              position: fixed;
              top: calc(18px + 40 * $pc-conversion * 2);
              left: 0;
              z-index: 5;
              width: 100%;
              background: #ffffff;
              border-top: 1px solid $line1;
              display: none;
              box-shadow: 0 10*$pc-conversion 10*$pc-conversion rgba(0, 0, 0, .1);

              .com-content1 {
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                padding: 30*$pc-conversion 0 60*$pc-conversion;
              }

              .dn-zuo {
                .dn-sha {
                  font-size: 24px;
                  color: #333333;
                  text-transform: capitalize;
                }

                .dn-xia {
                  display: flex;
                  flex-wrap: wrap;
                  width: 245*$pc-conversion *3;

                  .dp-a1 {
                    width: 215*$pc-conversion;
                    margin: 30*$pc-conversion 30*$pc-conversion 0 0;
                    padding: 12*$pc-conversion 0;
                    color: #333333;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px solid $line1;
                    cursor: pointer;
                    text-transform: capitalize;
                    &.router-link-active, &:hover {
                      color: $color1;
                    }
                  }
                }
              }

              .dn-you {
                .dp-img1 {
                  width: 380*$pc-conversion;
                  height: 160*$pc-conversion;
                }
              }

              .com-content2 {
                display: flex;
              }

              .dp-zuo {
                width: 400/1920*100%;
                padding: 50*$pc-conversion 0 0 190*$pc-conversion;

                .el-radio-group {
                  .el-radio {
                    display: block;
                    margin: 0 0 30*$pc-conversion;
                  }
                }
              }

              .dp-you {
                flex: 1;
                border-left: 1px solid $line1;

                .swiper2 {
                  .wrapper2 {
                    flex-wrap: wrap;
                    max-height: 80vh;
                    overflow-y: scroll;
                  }

                  .slide2 {
                    width: calc(100% / 3);
                    height: auto;
                    display: flex;
                    padding: 30*$pc-conversion;
                    border-bottom: 1px solid $line1;
                    border-right: 1px solid $line1;

                    .dp-picture {
                      width: 50%;
                      display: flex;
                      justify-content: center;
                      align-items: flex-start;

                      .dp-img1 {
                        max-width: 60%;
                      }
                    }

                    .dp-word {
                      width: 50%;

                      .dp-sha {
                        font-weight: 600;

                        .dp-a1 {
                          cursor: pointer;
                          color: #000000;

                          &:hover {
                            color: $color1;
                          }
                        }
                      }

                      .dp-xia {
                        line-height: 26px;
                        margin: 6px 0 0;

                        .dp-a1 {
                          cursor: pointer;
                          display: block;

                          &:hover {
                            color: $color1;
                          }
                        }
                      }
                    }
                  }
                }

                .swiper3 {
                  padding: 60*$pc-conversion;

                  .slide3 {
                    width: calc(100% / 5 - 2%);
                    margin: 0 calc(2% / 2);
                    height: 330*$pc-conversion;
                    cursor: pointer;

                    .dp-word {
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                      color: #ffffff;

                      .dp-img1 {
                        height: 30px;
                        margin: 0 0 20px;
                      }

                    }
                  }
                }
              }
            }
          }
        }
      }

      .dn-lang {
        font-size: 16px;
        color: #333333;
        display: flex;
        align-items: center;

        i {
          font-size: 22px;
          margin: 0 0 0 5px;
        }
      }

      .dn-sear {
        margin: 0 0 0 20px;

        i {
          font-size: 28px;
        }
      }

      .dn-menu-oper {
        display: none;
        margin: 0 0 0 10*$mobile-conversion;

        i {
          font-size: 36*$mobile-conversion;
        }
      }
    }
  }
}


@media screen and (max-width: 768px) {
  .com-header {
    .dn-upper {
      .dn-right {

        .dp-a1 {
          height: 60*$mobile-conversion;
          margin: 0 0 0 10*$mobile-conversion;

          &:last-of-type {
            padding: 0 15*$mobile-conversion;
          }

          i {
            font-size: 30*$mobile-conversion;
            margin: 0 8*$mobile-conversion;
          }
        }
      }
    }

    .dn-lower {
      padding: 20*$mobile-conversion 0;

      .dn-left {
        .dp-img1 {
          height: 50*$mobile-conversion;
        }
      }

      .dn-right {
        .dn-nav {
          display: none;
        }

        .dn-lang {
          font-size: 30*$mobile-conversion;

          i {
            font-size: 32*$mobile-conversion;
            margin: 0 0 0 5*$mobile-conversion;
          }
        }

        .dn-sear {
          margin: 0 0 0 30*$mobile-conversion;

          i {
            font-size: 36*$mobile-conversion;
          }
        }

        .dn-menu-oper {
          display: block;

        }
      }
    }

  }
}


</style>
